import { axiosInstance } from "@/api/apiClient";
import {
  VoicemailMessageApi,
  VoicemailMessageApiTelephonyViewsNinjaCallVoicemailMessageListVoicemailMessageRequest,
} from "@/api/client";
import { BASE_API } from "@/helpers/constants";

const api = new VoicemailMessageApi(undefined, BASE_API, axiosInstance);

export const getVoiceMailMessages = async (
  payload: VoicemailMessageApiTelephonyViewsNinjaCallVoicemailMessageListVoicemailMessageRequest
) => {
  return api.telephonyViewsNinjaCallVoicemailMessageListVoicemailMessage.bind(
    api
  )(payload);
};
